import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog } from './external-video.actions';
import { ExternalVideoState } from './external-video.state';
import { ExternalVideoData, ExternalVideoModel } from './model/external-video-data.model';

@Injectable({
  providedIn: 'root'
})
export class ExternalVideoDialogFacade {
  private readonly store = inject(Store);

  @Select(ExternalVideoState.open) open$: Observable<boolean>;
  @Select(ExternalVideoState.externalVideoData) externalVideoData$: Observable<ExternalVideoData>;

  openDialog(externalVideo: ExternalVideoModel) {
    this.store.dispatch(new OpenDialog(externalVideo));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
}
